// extracted by mini-css-extract-plugin
module.exports = {"uploadTitle":"AddChapter_uploadTitle__20Ruu","uploader":"AddChapter_uploader__327q0","orAddText":"AddChapter_orAddText__3yUl-"};